/* ======================================================================
   SortimentPlus 3.3 – Warenkorb als Seitenfenster
   - fängt alle Formulare an /cart/add ab und legt per AJAX in den Warenkorb
   - aktualisiert Inhalt über die Section Rendering API (/?sections=cart-drawer)
   - Mengenänderung und Entfernen direkt im Seitenfenster
   - fällt bei Fehlern auf das normale Absenden zurück
   ====================================================================== */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer || !window.fetch || !window.FormData) return;

  // Auf der Warenkorbseite selbst bleibt alles beim normalen Verhalten.
  if (document.body.classList.contains('template-cart')) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var panel = drawer.querySelector('.cart-drawer__panel');
  var lastFocus = null;
  var closeTimer = null;

  var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function setNotice(text, isError) {
    var notice = drawer.querySelector('[data-cart-drawer-notice]');
    if (!notice) return;
    notice.textContent = text || '';
    notice.classList.toggle('is-error', Boolean(isError));
    notice.hidden = !text;
  }

  function updateCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll('.cart-link[aria-label]').forEach(function (el) {
      el.setAttribute('aria-label', 'Warenkorb mit ' + count + ' Artikeln');
    });
  }

  function open() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
    if (!drawer.classList.contains('is-open')) lastFocus = document.activeElement;
    drawer.hidden = false;
    // Reflow, damit die Einblend-Animation greift.
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    document.documentElement.classList.add('cart-drawer-open');
    panel.focus({ preventScroll: true });
  }

  function close() {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('cart-drawer-open');
    closeTimer = setTimeout(function () {
      drawer.hidden = true;
    }, 260);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  }

  function refresh(noticeText, isError) {
    return fetch(root + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Section rendering failed');
        return response.json();
      })
      .then(function (data) {
        var html = data && data['cart-drawer'];
        if (!html) throw new Error('Section missing');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-content]');
        var current = drawer.querySelector('[data-cart-drawer-content]');
        if (fresh && current) current.replaceWith(fresh);
        updateCounts((fresh && fresh.dataset.itemCount) || '0');
        setNotice(noticeText, isError);
      });
  }

  function setBusy(form, busy) {
    form.querySelectorAll('button[type="submit"], button:not([type])').forEach(function (button) {
      button.classList.toggle('is-loading', busy);
      button.setAttribute('aria-busy', busy ? 'true' : 'false');
    });
    var id = form.getAttribute('id');
    if (id) {
      document.querySelectorAll('button[form="' + id + '"]').forEach(function (button) {
        button.classList.toggle('is-loading', busy);
        button.setAttribute('aria-busy', busy ? 'true' : 'false');
      });
    }
  }

  function showFormError(form, message) {
    var box = form.querySelector('.cart-add-error');
    if (!box) {
      box = document.createElement('p');
      box.className = 'cart-add-error';
      box.setAttribute('role', 'alert');
      form.appendChild(box);
    }
    box.textContent = message;
    setTimeout(function () {
      if (box && box.parentNode) box.parentNode.removeChild(box);
    }, 6000);
  }

  function productTitleFor(form) {
    var section = form.closest('[data-product-section]');
    var title = section && section.querySelector('.product-title, .product-mobile-heading__title');
    if (!title) {
      var card = form.closest('.product-card');
      title = card && card.querySelector('.product-card__title');
    }
    return title ? title.textContent.trim().replace(/\s+/g, ' ') : '';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (event.defaultPrevented) return;

    event.preventDefault();
    var formData = new FormData(form);
    if (event.submitter && event.submitter.name) formData.append(event.submitter.name, event.submitter.value);
    var title = productTitleFor(form);

    setBusy(form, true);
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (response) {
        return response.json().then(function (json) {
          return { ok: response.ok, json: json };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          var message = (result.json && (result.json.description || result.json.message)) || 'Der Artikel konnte nicht in den Warenkorb gelegt werden.';
          // Kam der Klick aus der Schnellkaufleiste (Button außerhalb des Formulars), ist das Formular evtl. nicht sichtbar:
          // dann den Hinweis im Seitenfenster zeigen.
          if (event.submitter && !form.contains(event.submitter)) {
            return refresh(message, true).then(open);
          }
          showFormError(form, message);
          return null;
        }
        return refresh(title ? '„' + title + '“ wurde in den Warenkorb gelegt.' : 'Artikel wurde in den Warenkorb gelegt.').then(open);
      })
      .catch(function () {
        // Netzwerk- oder Antwortfehler: klassisch absenden (führt zur Warenkorbseite).
        form.submit();
      })
      .then(function () {
        setBusy(form, false);
      });
  });

  // Klick auf das Warenkorb-Symbol öffnet das Seitenfenster statt der Warenkorbseite.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a.cart-link, [data-cart-drawer-open]');
    if (!link) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
    event.preventDefault();
    refresh('').then(open).catch(function () {
      window.location.href = link.getAttribute('href') || root + 'cart';
    });
  });

  drawer.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-drawer-close]')) {
      event.preventDefault();
      close();
      return;
    }
    var changeButton = event.target.closest('[data-cart-change]');
    if (!changeButton) return;
    event.preventDefault();
    var key = changeButton.getAttribute('data-cart-change');
    var quantity = parseInt(changeButton.getAttribute('data-quantity'), 10);
    if (isNaN(quantity) || quantity < 0) quantity = 0;
    drawer.classList.add('is-busy');
    fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          return { ok: response.ok, json: json };
        });
      })
      .then(function (result) {
        var message = '';
        if (!result.ok) message = (result.json && (result.json.description || result.json.message)) || 'Die Menge konnte nicht geändert werden.';
        return refresh(message, !result.ok);
      })
      .catch(function () {
        setNotice('Die Menge konnte nicht geändert werden. Bitte lade die Seite neu.', true);
      })
      .then(function () {
        drawer.classList.remove('is-busy');
        var again = drawer.querySelector('[data-cart-change="' + key + '"][data-quantity]');
        if (again) again.focus({ preventScroll: true });
        else panel.focus({ preventScroll: true });
      });
  });

  document.addEventListener('keydown', function (event) {
    if (!drawer.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    var items = Array.prototype.filter.call(panel.querySelectorAll(focusableSelector), function (el) {
      return el.offsetParent !== null;
    });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
